import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function AdminPagination({ page, total, limit, onPageChange, testidPrefix }) {
  const totalPages = Math.max(1, Math.ceil(total / limit));
  if (totalPages <= 1) return null;
  return (
    <div className="flex items-center justify-between mt-4 flex-wrap gap-2" data-testid={`${testidPrefix}-pagination`}>
      <span className="text-xs text-slate-500">{total} resultados en total</span>
      <div className="flex items-center gap-2">
        <button
          data-testid={`${testidPrefix}-prev-page`}
          aria-label="Página anterior"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          className="h-9 w-9 flex items-center justify-center rounded-lg border border-slate-200 text-slate-600 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-slate-50"
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
        <span data-testid={`${testidPrefix}-page-indicator`} className="text-sm font-medium text-slate-700 px-1">
          {page} / {totalPages}
        </span>
        <button
          data-testid={`${testidPrefix}-next-page`}
          aria-label="Página siguiente"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          className="h-9 w-9 flex items-center justify-center rounded-lg border border-slate-200 text-slate-600 disabled:opacity-40 disabled:cursor-not-allowed hover:bg-slate-50"
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
